import { Inject, Injectable } from '@angular/core';

import { pipe, Subject, throwError, UnaryFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { COMPANY_ID } from '@recruitee/common';
import { AuthService, HttpApiErrorHandlerService } from '@recruitee/http';

@Injectable()
export class WebappHttpApiErrorHandlerService implements HttpApiErrorHandlerService {
  public internalServerError$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    @Inject(COMPANY_ID) private currentCompanyId: number,
  ) {}

  public handleError(url: string): UnaryFunction<any, any> {
    return pipe(
      catchError(error => {
        switch (error.status) {
          case 401:
            this.authService.onUnauthorized(error);
            break;
          case 403:
            this.authService.onForbidden(error, this.currentCompanyId, url);
            break;
          case 500:
            this.internalServerError$.next(error);
            break;
          default:
            break;
        }
        return throwError(error);
      }),
    );
  }
}
